// A numbered rail: each step's number sits on a line that runs down to the next one.
.steps {
  max-width: 44rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  position: relative;
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr);
  column-gap: 1rem;
  padding-bottom: 1.5rem;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child)::before {
    content: "";
    position: absolute;
    top: 2.25rem;
    bottom: 0.25rem;
    inset-inline-start: calc(1rem - 0.5px);
    width: 1px;
    background: var(--color-border);
  }
}

.number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--color-primary-border);
  border-radius: 999px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 0.875rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.content {
  padding-top: 0.25rem;
}

.heading {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.5rem;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
}

.body {
  margin: 0.25rem 0 0;
  color: color-mix(in srgb, var(--color-foreground) 82%, var(--color-muted));
  font-size: 0.9375rem;
  line-height: 1.65;
}
